import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { getResourceType } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { EditableValuesByResource } from 'routes/BudgetModule/helpers/hooks/writeScopes';

/**
 * From a given resource and list of resource rights, determine if a user can edit
 * anything related to this resource
 */
export const canEditResource = (
    editableValuesByResource: EditableValuesByResource,
    resourceSoftwareId: string,
    budgetProposal: BudgetProposalT,
): boolean => {
    const resourceType = getResourceType(budgetProposal.by);
    const editablesValues = editableValuesByResource[resourceType];
    return editablesValues.includes(resourceSoftwareId);
};
